import { createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "drawer-header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Filters", -1)
const _hoisted_3 = { class: "form-parent drawer-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Preset", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3 add-star-to-field" }, "Score", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Age", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Sex", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Male")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Female")
const _hoisted_11 = { class: "button-box drawer-buttons" }
const _hoisted_12 = { class: "form-parent full-width" }
const _hoisted_13 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.state.drawerOpen,
    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.state.drawerOpen = $event)),
    direction: "rtl",
    modal: false,
    onClosed: _cache[34] || (_cache[34] = ($event: any) => (_ctx.drawerClosed()))
  }, {
    title: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("a", {
          href: "#",
          class: "reset-filters",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clearFilters()), ["prevent"]))
        }, "Reset filters")
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          "label-position": "top",
          "label-width": "100px",
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "presetForm"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_el_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, {
                  class: "input-dropdown",
                  trigger: "click"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DropdownFilter, {
                          class: "form-dropdown-filter",
                          filterData: _ctx.state.presets,
                          showEmptyGroups: true
                        }, null, 8, ["filterData"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: { placeholder: _ctx.state.presets.values === [] }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.preset) + " ", 1),
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_el_form_item, { class: "parent-item parent-full-size" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: " ",
                      class: "score-name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.scoreNames.MMSE,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.scoreNames.MMSE = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "From",
                      prop: "score_mmse_from",
                      class: "score-value"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.score_mmse_from,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.score_mmse_from = $event)),
                          maxlength: 2,
                          onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trim('score_mmse_from'))),
                          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mutateScores()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "To",
                      prop: "score_mmse_to",
                      class: "score-value"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.score_mmse_to,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.score_mmse_to = $event)),
                          maxlength: 2,
                          onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trim('score_mmse_to'))),
                          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mutateScores()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: " ",
              prop: "operator_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "operator-select",
                  modelValue: _ctx.form.operator_type,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.operator_type = $event)),
                  placeholder: "Operator"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "",
                      value: null
                    }),
                    _createVNode(_component_el_option, {
                      label: "And",
                      value: "And"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Or",
                      value: "Or"
                    }),
                    _createVNode(_component_el_option, {
                      label: "AND/OR",
                      value: "AndOr"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "parent-item parent-full-size" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: " ",
                      class: "score-name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.scoreNames.ADAScog,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.scoreNames.ADAScog = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "From",
                      prop: "score_adascog_from",
                      class: "score-value"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.score_adascog_from,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.score_adascog_from = $event)),
                          maxlength: 2,
                          onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.trim('score_adascog_from'))),
                          onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mutateScores()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "To",
                      prop: "score_adascog_to",
                      class: "score-value"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.score_adascog_to,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.score_adascog_to = $event)),
                          maxlength: 2,
                          onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.trim('score_adascog_to'))),
                          onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.mutateScores()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_7,
            _createVNode(_component_el_form_item, { class: "parent-item parent-full-size" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "From",
                      prop: "age_from",
                      class: "age-value"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.age_from,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.age_from = $event)),
                          maxlength: 3,
                          onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.trim('age_from'))),
                          onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.mutateScores()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "To",
                      prop: "age_to",
                      class: "age-value last-value"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.age_to,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.age_to = $event)),
                          maxlength: 3,
                          onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.trim('age_to'))),
                          onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.mutateScores()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_8,
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.form.sex_types,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.sex_types = $event)),
                  onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.mutateScores()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, { label: "M" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "F" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode("div", _hoisted_11, [
          _createVNode("a", {
            href: "#",
            class: "reset-filters",
            onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.savePreset()), ["prevent"])),
            style: { visibility: _ctx.showSavePreset ? 'visible' : 'hidden' }
          }, "Save as preset", 4),
          _createVNode("div", null, [
            _createVNode("button", {
              class: "button secondary",
              onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"]))
            }, " Cancel "),
            _createVNode("button", {
              class: "button",
              onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"])),
              disabled: !_ctx.isRequiredFilled
            }, " Apply ", 8, ["disabled"])
          ])
        ])
      ]),
      _createVNode(_component_el_dialog, {
        title: "Save as preset",
        modelValue: _ctx.state.savePopupOpen,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.state.savePopupOpen = $event)),
        width: "45%",
        top: "30vh"
      }, {
        footer: _withCtx(() => [
          _createVNode("span", _hoisted_13, [
            _createVNode("button", {
              class: "button secondary",
              style: {"margin-right":"16px"},
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.state.savePopupOpen = false))
            }, " Cancel "),
            _createVNode("button", {
              class: "button",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.confirmSavePreset()))
            }, " Save ")
          ])
        ]),
        default: _withCtx(() => [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_el_form, {
              class: "full-width",
              "label-position": "top",
              "label-width": "100px",
              ref: "presetNameForm",
              model: _ctx.nameForm,
              rules: {
            name: [
              {
                required: true,
                message: _ctx.PRESET_NAME_REQUIRED_MESSAGE,
                trigger: 'blur',
              },
            ],
          }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Preset name",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.nameForm.name,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.nameForm.name = $event)),
                      maxlength: 50,
                      onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.trim('name')))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}